import { useLayoutEffect } from 'react';
import { SearchResponseDeviceType } from '@sitecore-search/data';
import useContentBlock from './hooks/useContentBlock.js';
const ContentBlockSEOWidget = () => {
    const { queryResult: { data: { appearance: { templates: { html: { devices: { [SearchResponseDeviceType.DESKTOP]: { content: htmlContent = null } = {} } = {} } = {}, } = {}, } = {}, } = {}, }, } = useContentBlock();
    // sets widget content
    useLayoutEffect(() => {
        if (htmlContent) {
            document.head.insertAdjacentHTML('afterbegin', htmlContent);
        }
    }, [htmlContent]);
    return null;
};
export default ContentBlockSEOWidget;
